import SignInForm from "./SignInForm";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Storage from "@/app/core/util/Storage";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import GenericHeader from "@/app/core/layouts/main/components/GenericHeader";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { RegisterMoneyRules } from "@/app/core/util/helpers/MoneyHelper";

export default function SignIn(props) {
  const [authenticate, setAuthenticate] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(form) {
    setLoading(true);
    await AccountController.Login(form.values, res => {
      if (res.message) {
        toast.info(res.message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      } else {
        Storage.setUserData({ ...res });
        AccountController.Get(res.userId, result => {
          Storage.setUserData({ ...res, ...result });
          RegisterMoneyRules();

          setTimeout(() => {
            setAuthenticate(true);
          }, 500)
        })
      }
    })

    setLoading(false);
  }

  if (authenticate) return <Redirect to="/app" />;
  return (
    <div id="page-container">
      <main id="main-container">
        <div
          className="bg-white"
        // style={{
        //   height: "100%",
        //   backgroundImage: "url('assets/media/photos/BG-login.png')",
        //   BackgroundPosition: "bottom"
        // }}
        >
          <GenericHeader register={true} />
          <div className="row no-gutters bg-black-25">
            <div className="hero-static col-md-6 d-flex align-items-center bg-white">
              <div className="p-3 w-100">
                <div className="mb-3 text-center">
                  <p className="text-uppercase font-w700 font-size-sm text-warning">
                    {Translate(Message.Login.Welcome)}
                  </p>
                </div>

                <div className="row no-gutters justify-content-center">
                  <div className="col-sm-8 col-xl-6">
                    <SignInForm
                      submit={(form) => onSubmit(form)}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-white"
              style={{
                height: "100%",
                backgroundImage: "url('assets/media/photos/BG-login.png')",
                BackgroundPosition: "bottom"
              }}
            >
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  {/* Colocar um texto legal */}
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Copyright <b>BeeMove</b> &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main >
      <ToastContainer />
    </div >
  );
}
